<template>
  <section
    :class="[
      'paragraph__fields',
      { 'paragraph__fields--light': isFestivalYear },
    ]"
  >
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: "ArticleRelatedFields",
  props: {},
  data() {
    return {};
  },
  computed: {
    isFestivalYear() {
      return this.$route.meta.isRenderingFestivalTheme;
    },
  },
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
.paragraph {
  &__fields {
    @include article-content-spacing(mobile);

    @include for-tablet {
      @include article-content-spacing(tablet);
    }

    @include for-desktop {
      @include article-content-spacing(desktop);
      border-left: 1px solid $color-border;
      display: inline-block;
      vertical-align: top;
    }

    &--light {
      @include for-tablet {
        padding: 15px;
      }

      @include for-desktop {
        padding-left: 45px;
        padding-right: 0;
        margin-left: 30px;
        border-color: $color-light-border;
      }
    }
  }
}
</style>
